
export class MediaPreviewModel {

  public url: string;
  public filename: string;
  public displayName: string;

}
